import { makeStyles } from '@material-ui/core'
import React from 'react'
import { tokens } from './tokens'
import { Container } from './Container'
import { SectionTitle } from './SectionTitle'

const PROBLEM_ROWS = [
    [
        { title: 'Manual Testing Is Time-Consuming', text: 'Relying on manual probing slows down testing, increases labor cost, and introduces human error.' },
        { title: 'Automated Test Fixtures', text: "SLS's functional and ICT fixtures automate the entire testing workflow—cutting down time and improving precision." },
    ],
    [
        { title: 'Inconsistent Testing Results', text: 'Variation in probe contact and operator handling leads to unreliable test outcomes and repeat failures.' },
        { title: 'High-Precision Fixtures', text: 'Our fixtures use high-grade materials and guided probe designs to ensure consistent, repeatable results every time.' },
    ],
    [
        { title: 'Frequent Fixture Failures', text: 'Low-quality test jigs degrade quickly, causing downtime and production halts.' },
        { title: 'Durable Build Quality', text: 'Built using Delrin, FR4, and anti-static acrylics—SLS fixtures are designed for long lifecycle use in demanding environments.' },
    ],
    [
        { title: 'Lack of Software Integration', text: "Fixtures that don't work with your test software slow down processes and complicate setups." },
        { title: 'Seamless Software Compatibility', text: 'Our fixtures integrate smoothly with LabVIEW, TestStand, Python, and all major test platforms—no patchwork required.' },
    ],
    [
        { title: 'No Post-Delivery Support', text: 'Fixture vendors often disappear after shipping—leaving you with unresolved issues or scaling challenges.' },
        { title: 'Lifetime Tech Support', text: 'We offer full documentation, training, and ongoing technical support to ensure your test system grow with your needs.' },
    ],
]

const useStyles = makeStyles(() => ({
    section: { background: tokens.colorPrimaryLight, padding: '70px 0' },
    grid: { display: 'flex', flexDirection: 'column', gap: 16 },
    row: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: 16,
        '@media (max-width: 860px)': { gridTemplateColumns: '1fr' },
    },
    card: {
        display: 'flex',
        gap: 16,
        alignItems: 'flex-start',
        background: '#fff',
        borderRadius: tokens.radiusMd,
        padding: '22px 24px',
        boxShadow: tokens.shadowSm,
        transition: `transform ${tokens.transition}, box-shadow ${tokens.transition}`,
        '&:hover': { transform: 'translateY(-4px)', boxShadow: tokens.shadowMd },
    },
    cardTitle: { fontSize: '20px', marginBottom: 6, color: tokens.colorBlack, letterSpacing: '0.02em' },
    cardText: { fontSize: '.9rem', color: tokens.colorTextLight, margin: 0, fontFamily: tokens.fontBody },
    badge: {
        flex: '0 0 auto',
        width: 30,
        height: 30,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '.85rem',
        fontWeight: 700,
        color: '#fff',
    },
    bad: { background: tokens.colorAccentRed },
    good: { background: tokens.colorAccentGreen },
}))

export function Problems() {
    const classes = useStyles()
    return (
        <section className={classes.section} id="problems">
            <Container>
                <SectionTitle>PCBA Testing Problems We Solve</SectionTitle>
                <div className={classes.grid}>
                    {PROBLEM_ROWS.map((row, i) => (
                        <div className={classes.row} key={i}>
                            <div className={classes.card}>
                                <span className={`${classes.badge} ${classes.bad}`} aria-hidden="true">&#10005;</span>
                                <div>
                                    <h3 className={classes.cardTitle}>{row[0].title}</h3>
                                    <p className={classes.cardText}>{row[0].text}</p>
                                </div>
                            </div>
                            <div className={classes.card}>
                                <span className={`${classes.badge} ${classes.good}`} aria-hidden="true">&#10003;</span>
                                <div>
                                    <h3 className={classes.cardTitle}>{row[1].title}</h3>
                                    <p className={classes.cardText}>{row[1].text}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </Container>
        </section>
    )
}
